import {AppRoute} from '@vizir-banking/banking-app-core/dist/navigation/app-route/app-route';
import {RoutesManager} from '@vizir-banking/banking-app-core/dist/hooks/routes-manager';

import Home from '~/home/screens/home/home.container';
import definitions from '~/home/navigation/screen-definitions';

RoutesManager.addSection('home', definitions, (): AppRoute[] => {
  return [new AppRoute(definitions.home, Home, {isPrivate: true})];
});
